import { PRODUCT_WITH_ACCESS_MAPPING, Products } from '../constants/product';
import { ProductName } from '../constants/productName';

export function getProductsAccess(
  organizations: IWCSpace[],
  org?: IWCSpace,
): Partial<Record<ProductName, boolean>> {
  const productAccess: Partial<Record<ProductName, boolean>> = {};
  const productWithAccessMapping: Record<
    'drives' | 'mails' | 'kchats' | 'has_ai-tools',
    ProductName
  > = PRODUCT_WITH_ACCESS_MAPPING;

  // The products can have different types (array, boolean). This function handles both cases.
  const checkProductAccess = (org: IWCSpace, key: string): boolean => {
    const orgProduct = org.products[key];

    if (!orgProduct) return false;

    if (Array.isArray(orgProduct)) {
      return orgProduct.length > 0;
    }

    return orgProduct === true;
  };

  if (org) {
    Object.entries(productWithAccessMapping).forEach(([key, productName]) => {
      productAccess[productName] = checkProductAccess(org, key);
    });
    return productAccess;
  }

  Object.entries(productWithAccessMapping).forEach(([key, productName]) => {
    productAccess[productName] = organizations.some((org) => checkProductAccess(org, key));
  });

  return productAccess;
}

export function disableUnavailableProducts(
  products: Partial<Products>,
  productAccess: Partial<Record<ProductName, boolean>>,
) {
  const updatedProducts = { ...products };

  Object.entries(productAccess).forEach(([productName, hasAccess]) => {
    const product = updatedProducts[productName as ProductName];

    if (product) {
      product.isDisabled = !hasAccess;
    }
  });

  return updatedProducts;
}

export function removeDisabledProducts(products: Partial<Products>, org?: IWCSpace) {
  const hasMyKSuite = org && typeof org.products.my_ksuite?.id === 'number';
  if (hasMyKSuite) {
    return Object.entries(products).reduce((products, [key, product]) => {
      if (!product.isDisabled) products[key] = product;
      return products;
    }, {} as Partial<Products>);
  }

  return products;
}
